export enum AuthAction {
  SIGN_UP = "sign-up",
  SIGN_IN = "sign-in",
}
